import React from 'react'
import isNil from 'lodash/isNil'
import { Card } from 'semantic-ui-react'

const BaseCardGroup = ({
  settings,
  style,
  children,
}) => {
  return (
    <Card.Group {...settings} style={style}>
      {children}
    </Card.Group>
  )
}

const CardGroup = ({
  renderElement,
  renderChildren,
  ...props,
}) => {
  return (
    renderElement(
      BaseCardGroup,
      {
        ...props,
        children: renderChildren(),
      },
    )
  )
}

CardGroup.propTypes = {}
CardGroup.defaultProps = {}

export default CardGroup


// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/cardGroup/CardGroup.js